export default {
  spaceDark: '#090F16',
  rocketRed: '#FF3A27',
  ufoTurquoise: '#A0E1DA',
  disabledGreyBackground: '#313131',
  explainBlue: '#005fb3',
  teams: {
    0: '#FF3A27',
    1: '#A0E1DA'
  },
  menuGold: 'orange',
  // menuGold: '#F6D35E'
  menuGoldDark: '#886100',
  yellow: '#FFFF00',
  selectGreen: '#00FF00' // set this as the three.js green
  // #00FF00 green is limegreen
}